import { section } from '@/glow';
import { AnimateCollectionList } from '@/lib/animation';

section('collection-list', {
  onLoad() {
    this.AnimateCollectionList = AnimateCollectionList(this.container);
  },

  onUnload() {
    this.AnimateCollectionList?.destroy();
  }
});
